import { useEffect, useState } from "react";
import { getStorageItem, setStorageItem } from "@/helpers/storage.helpers";

export const menuToggleKey = "[";
export const menuToggleStateKey = "nimbusMenuState";
const CLOSED = "closed";
const OPEN = "open";

/**
 * Provides menu toggling state, keyboard event binding and storage.
 */
const useMenuToggleState = () => {
  const storedMenuState = getStorageItem(menuToggleStateKey, null) !== CLOSED;
  const [expanded, setExpanded] = useState(storedMenuState);

  useEffect(() => {
    setStorageItem(menuToggleStateKey, expanded ? OPEN : CLOSED);
  }, [expanded]);

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      const inputElements = ["input", "textarea"];

      if (inputElements.includes(target.tagName?.toLowerCase())) {
        return;
      }

      if (event.key === menuToggleKey) {
        event.stopImmediatePropagation();
        setExpanded((state) => !state);
      }
    };

    window.addEventListener("keydown", handleKeydown);
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  return [expanded, setExpanded] as const;
};

export default useMenuToggleState;
